import { useModalState } from './useModalState';
import { useModalBehavior } from './useModalBehavior';
import * as React from 'react';

export const Modal = () => {
  const { state } = useModalState();
  const { modalVisibility, onClose } = useModalBehavior(state);
  return (
    <>
      {modalVisibility && (
        <div
          style={{ display: 'block' }}
          className="modal bg-light bg-opacity-50"
          tabIndex={-1}
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className={['modal-dialog modal-dialog-centered', state.size].join(' ')}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  {state.header}
                </h5>
                <button
                  onClick={onClose}
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">{state.content}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
